module.exports = __webpack_public_path__ + "697c761bc947084f270c39ae6fbeb72e.svg";